import {
  basicInfoSections,
  historySections,
  moreSections,
  reportSections,
  symptomCategories,
  symptomLevels,
  type SectionConfig,
} from '@/mocks/questionnaire';

export const basicSections: SectionConfig[] = basicInfoSections;
export const reportSectionList: SectionConfig[] = reportSections;
export const historySectionList: SectionConfig[] = historySections;
export const moreSectionList: SectionConfig[] = moreSections;

export const FIELD_LABELS: Record<string, string> = {};
export const OPTION_LABELS: Record<string, Record<string, string>> = {};
export const SYMPTOM_LABELS: Record<string, string> = {};

[basicInfoSections, reportSections, historySections, moreSections].forEach((sections) => {
  sections.forEach((section) => {
    section.fields.forEach((field) => {
      FIELD_LABELS[field.name] = field.label;
      if (field.options) {
        const map: Record<string, string> = {};
        field.options.forEach((option) => {
          map[option.value] = option.label;
        });
        OPTION_LABELS[field.name] = map;
      }
    });
  });
});

symptomCategories.forEach((category) => {
  category.items.forEach((item) => {
    FIELD_LABELS[item.name] = item.label;
    SYMPTOM_LABELS[item.name] = item.label;
    const map: Record<string, string> = {};
    symptomLevels.forEach((level) => {
      map[level.value] = level.label;
    });
    OPTION_LABELS[item.name] = map;
  });
});

export function optionText(name: string, value: string | null | undefined): string {
  if (!value) return '';
  return OPTION_LABELS[name]?.[value] || value;
}

export function optionListText(name: string, values: string[] | null | undefined): string {
  if (!values || !values.length) return '';
  return values.map((item) => OPTION_LABELS[name]?.[item] || item).join('、');
}

export function fieldText(row: Record<string, unknown>, name: string): string {
  const value = row[name];
  if (Array.isArray(value)) return optionListText(name, value as string[]);
  if (typeof value === 'string') return optionText(name, value);
  return '';
}

export function formatTime(iso: string): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}